import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  container: css`
    && {
      box-shadow: none;
      background: var(--colorScheme-background, #fff);
    }

    :global(html[data-theme='dark']) & {
      background: var(--colorScheme-background, #191918) !important;
    }
  `,
}
